<template>
  <TContainer>
    <div v-for="(item, index) in items" :key="index">
      <TContentFigure
        :desktop-figure-rigth="item.desktopImageRight"
        :desktop-items-center="true"
        :classes="'pt-6 pb-12 lg:py-12'"
      >
        <template #figure>
          <TLazyimg
            :src="item.image"
            classes="block w-full h-full aspect-w-3 aspect-h-2"
            classes-img="block w-full h-full rounded-xl"
            alt=""
          />
        </template>
        <template #content>
          <TTitle tag="h2" size="3xl">
            <span v-html="item.title" />
          </TTitle>
          <TProse classes="leading-6 text-lg" :responsive="false">
            <span v-html="item.content" />
          </TProse>

          <UButton
            v-if="item.cta"
            variant="solid"
            size="lg"
            :label="item.cta.text"
            :to="item.cta.url"
            external
            class="mt-8"
            rel="nofollow"
          />
        </template>
      </TContentFigure>
    </div>
  </TContainer>
</template>

<script setup lang="ts">
type SContentFigureDefaultItemType = {
  title: string
  content: string
  desktopImageRight: boolean
  image: string
  cta?: {
    text: string
    url: string
  } | null
}

export interface propsInterface {
  items: Array<SContentFigureDefaultItemType>
}
defineProps<propsInterface>()
</script>
